import { Link } from "react-router-dom";
import { Button } from "@eduviaos/ui-kit";
import { ErrorState } from "@/components/ErrorState";

export function NotFoundPage() {
  return (
    <ErrorState
      title="Page not found"
      body={
        <>
          The link you opened doesn't match any EduViaOS public page. If you were trying to submit
          an admission enquiry, please use the URL the institution shared with you.
        </>
      }
      cta={
        <Button asChild variant="outline">
          <Link to="/">Back to home</Link>
        </Button>
      }
    />
  );
}
